import {
  getRequest,
  postRequest
} from '@/utils/api'

// 查询充电预警列表
export function listAlarm(params) {
  return postRequest('/api/coo/alarm/list', params)
}

// 查询充电预警详情
export function getAlarm(id) {
  return postRequest('/api/coo/alarm/get', { id })
}

// 新增充电预警
export function addAlarm(data) {
  return postRequest('/api/coo/alarm/add', data)
}

// 更新充电预警
export function updateAlarm(data) {
  return postRequest('/api/coo/alarm/update', data)
}

// 删除充电预警
export function delAlarm(id) {
  return postRequest('/api/coo/alarm/delete', { id })
}

// 推送单条预警
export function pushAlarm(id) {
  return postRequest('/api/coo/alarm/push', { id })
}

// 批量推送预警
export function batchPushAlarm(data) {
  return postRequest('/api/coo/alarm/push-batch', data)
}

// 导入充电预警
export function importAlarm(data) {
  return postRequest('/api/coo/alarm/import', data)
}

// 下载预警导入模板
export function downloadAlarmTemplate() {
  return getRequest('/api/coo/template/alarm/template')
}

// 查询推送日志
export function listPushLog(params) {
  return postRequest('/api/coo/push/log/list', params)
}

// 重新推送
export function retryPush(id) {
  return postRequest('/api/coo/push/log/retry', { id })
}
